import { withTranslation } from 'next-i18next'
import React from 'react'

import { Button } from '../../../ui/buttons/index'
import { Modal, ModalBody, ModalClose } from '../../../ui/modals'
import { Props } from './index'

type State = {
  messageText: string
}

// TODO: refactor class component
class ReportModalContainer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      messageText: '',
    }
  }

  handleMessageChange = e => {
    this.setState({ messageText: e.target.value })
  }

  handleSendClick = e => {
    this.props.sendReport(this.props.resource, this.state.messageText)
  }

  render() {
    const { resource, closeModal } = this.props
    const { t } = this.props
    const { messageText } = this.state

    return (
      <Modal id="report-a-problem" className="fs-unmask">
        <ModalClose onClose={closeModal} />
        <ModalBody centered className="modal--report-a-problem">
          <div className="modal__header">
            <h1>
              <>{t(`common:report_problem.${resource.type}_modal_title`)}</>
            </h1>
          </div>
          <div className="modal__prompt">
            <>{t(`common:report_problem.${resource.type}_modal_prompt_text`)}</>
          </div>
          <div style={{ padding: 20 }} className="field">
            <div className="field">
              <label
                className="field__label"
                htmlFor="report-a-problem-message"
              >
                <>{t(`common:report_problem.modal_message_field_label`)}</>
              </label>
              <textarea
                id="report-a-problem-message"
                style={{ width: '100%', minWidth: '25em', height: '8em' }}
                onChange={this.handleMessageChange}
                value={messageText}
              />
            </div>
            <Button className="pull-right" wide onClick={this.handleSendClick}>
              <>{t(`common:report_problem.modal_send_button_label`)}</>
            </Button>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

export default withTranslation()(ReportModalContainer)
